import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["message"]
    static values = {
        delay: { type: Number, default: 2600 },
        hiddenClass: { type: String, default: "hidden" }
    }

    connect() {
        this.hide()
    }

    show() {
        // Clear any existing timeout
        if (this.timeout) {
            clearTimeout(this.timeout)
        }

        // Show the notification
        this.element.classList.remove(this.hiddenClassValue)

        // Auto-hide after delay
        this.timeout = setTimeout(() => {
            this.hide()
        }, this.delayValue)
    }

    hide() {
        this.element.classList.add(this.hiddenClassValue)
    }

    // Allow updating message from outside
    updateMessage(message) {
        if (this.hasMessageTarget) {
            this.messageTarget.textContent = message
        }
    }
}
